// JavaScript Document
//components/configuration/standard/forms/Strobe.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import {flexbox} from '@material-ui/system';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
	},
	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
  maxDisplayGrid: {
	  minHeight: 300
  }
}));

export default function Strobe(props) {
  	const classes = useStyles();
	//inherited variables
  	const {id, delay, duration, onChange} = props;
	//locally stored/copied variables
	const [cid, setCid] = React.useState(0);
	//local state varialbes user will change
	const [onDelay, setOnDelay] = React.useState(99);
	const [period, setPeriod] = React.useState(10);
	//Local constant for maximum value
	const max = 127500;
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(
			//inherited config ID is null
			cid === 0 || 
			cid === undefined || 
			cid === null || 
			cid === "0" || 
			//inherited daysetting has changed
			cid !== id 
			//updated from server
			//|| loadedToken != token
		) {
			//console.log('config has changed');
			setCid(id);
			setOnDelay(delay);
			setPeriod(duration);
		}
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	//Handle update parent if onChange is provided
	const handleUpdateParent = (delayNum, onPeriod) => {
		if(onChange){
			console.log('Updating parent');
			onChange(delayNum, onPeriod);
		}
	}
	

	
	//handle change timing value
	const handleChangeValue = (e) => {
		let setting = e.target.name;
		let value = parseInt(e.target.value);
		
		//clean the value
		if(isNaN(value) || value < 0){
			value = 0;
		} else if(value > max){
			value = max;
		}
		if(setting === 'onDelay'){
			setOnDelay(value);
			handleUpdateParent(value, period);
		} else if(setting === 'period'){
			setPeriod(value);
			handleUpdateParent(onDelay, value);
		}
	}
	
  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<Card className={classes.advancedCard}>
			<CardHeader title="Strobe" />
	  		<CardContent className={classes.advancedContent}>
	  				<TextField 
							id="onDelay" 
							name="onDelay"
							label="Delay"
							value={onDelay.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeValue}
							type="number" 
							inputProps={{min: '0', max:max.toString(), step:'50', style: {textAlign:'center'}}}
					/>
					<TextField 
							id="period" 
							name="period"
							label="Duration"
							value={period.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeValue}
							type="number" 
							inputProps={{min: '0', max:max.toString(), step:'50', style: {textAlign:'center'}}}
					/>
	  		</CardContent>
	  	</Card>
  );
}
